import { TextField } from '@mui/material';
import React from 'react';
import './CustomTextField.css'

export const CustomTextField = ({ label, value, size, isLabel = true, className }) => {

  return (
    <div className={`customTextField-container ${size} ${className}`}>
      {isLabel && <div className='customTextField-title'>{label}</div>}      
      <div className='customTextField-body'>{value}</div>
    </div>
  );
};
